import useQueryParamBoolean from './useQueryParamBoolean'

/**
 * @returns Whether edit mode is active, and a function to set it.
 */
export default function useEditMode(): [boolean, (value: boolean) => void] {
  return useQueryParamBoolean('editMode')
}
